import { render, staticRenderFns } from "./RequestedMonthlyRentalPrice.vue?vue&type=template&id=68fdec7e&"
import script from "./RequestedMonthlyRentalPrice.vue?vue&type=script&lang=ts&"
export * from "./RequestedMonthlyRentalPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports